import { render } from "./WpeHome.vue?vue&type=template&id=122d642b"
import script from "./WpeHome.vue?vue&type=script&lang=js"
export * from "./WpeHome.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/WpeHome.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "122d642b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('122d642b', __exports__)) {
    api.reload('122d642b', __exports__)
  }
  
  module.hot.accept("./WpeHome.vue?vue&type=template&id=122d642b", () => {
    api.rerender('122d642b', render)
  })

}


export default __exports__